import { css } from 'styled-components'
import { only } from 'styled-breakpoints'
import { TABLET } from '../lib/constant'

const responsiveStyle = css`
	box-sizing: border-box;
	position: relative;
	margin-left: auto;
	margin-right: auto;
	width: 100%;
	max-width: 1180px;
	${only(TABLET)} {
		padding-left: 16px;
		padding-right: 16px;
	}
`

export default responsiveStyle
